import { render, staticRenderFns } from "./TbWorkPermitReport.vue?vue&type=template&id=0935fb30&scoped=true"
import script from "./TbWorkPermitReport.vue?vue&type=script&lang=js"
export * from "./TbWorkPermitReport.vue?vue&type=script&lang=js"
import style0 from "./TbWorkPermitReport.vue?vue&type=style&index=0&id=0935fb30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0935fb30",
  null
  
)

export default component.exports